import Filterlist from "../../components/Filterlist";

export default function FilterlistPage() {
    return (
        <Filterlist />
    )
};